<template>
  <div class="footer" @click="_info()" style="cursor:pointer">
    <div class="width">
      <div>2022-2024 Shanghai Qidi Technology Co., Ltd. All Rights Reserved {{$t('footer')}}</div>
      <div class="footer_info flex_center">
        沪ICP备2022023716号-1
        <img class="g_icon"  src="@img/common/g_icon.jpg" alt />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    _info() {
      window.open(
        "https://beian.miit.gov.cn"
      );
    },
  },
};
</script>
<style lang="less" scoped>
.footer {
  background: @mainColor;
  text-align: center;
  height: 120px;
  line-height: 26px;
  color: @whiteColor;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 12px;

  .g_icon{
    width: 15px;
    margin-left: 10px;
    cursor: pointer;
  }
  // flex-direction: column;
}
</style>